
// Agreement is a read on how tightly stakeholders cluster (lower SD = tighter).
//   High   if spread <= AGREEMENT_HIGH_MAX
//   Low    if spread >= AGREEMENT_LOW_MIN
//   Medium otherwise
export const AGREEMENT_HIGH_MAX = 0.70;
export const AGREEMENT_LOW_MIN = 1.05;

export const AGREEMENT = {
    HIGH: { label: 'High', modifier: 'high' },
    MEDIUM: { label: 'Medium', modifier: 'medium' },
    LOW: { label: 'Low', modifier: 'low' },
};

export const agreementForSpread = (spread) => {
    if (spread <= AGREEMENT_HIGH_MAX) return AGREEMENT.HIGH;
    if (spread >= AGREEMENT_LOW_MIN) return AGREEMENT.LOW;
    return AGREEMENT.MEDIUM;
};

// Horizontal position (0..100%) of a mean value across the scale's evenly-spaced
// score columns: the lowest score sits at the centre of the first column and the
// highest at the centre of the last (1..6, or 1..4 on the 4-point scale).
export const meanToPct = (value, scale) => {
    const cols = scale.max - scale.min + 1;
    return ((value - scale.min + 0.5) / cols) * 100;
};

// Sort modes offered by the toolbar toggle.
export const SORTS = [
    { id: 'favorable', label: 'Sort · Favorable %' },
    { id: 'spread', label: 'Sort · Spread' },
    { id: 'az', label: 'Sort · A–Z' },
];

// Returns a new, sorted copy of the rows for the given mode.
export const sortRows = (rows, mode) => {
    const copy = [...rows];
    if (mode === 'favorable') {
        // Highest favourable first.
        return copy
    }
    if (mode === 'spread') {
        // Widest spread (most disagreement) first.
        return copy.sort((a, b) => b.spread - a.spread);
    }
    // Alphabetical.
    return copy.sort((a, b) => a.category.localeCompare(b.category));
};


export const HEADER_TEXT = (scale) => ({
    title: "How ratings are actually spread",
    description: `Two categories can share a mean while stakeholders disagreed underneath. This view shows the full ${scale.min}–${scale.max} distribution per category with Self and All But Self means overlaid.`
})